/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Email_InvalidInputs */



/**
* | output |
* | --- |
* | "Enter a valid email address." |
*
* @param {Login_Email_InvalidInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_email_invalid = /** @type {((inputs?: Login_Email_InvalidInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Email_InvalidInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geef een geldig e-mailadres in.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisissez une adresse e-mail valide.")
	return /** @type {LocalizedString} */ ("Enter a valid email address.")
});